// One API client for the whole web app. The base URL comes from runtime config (public/config.js),
// then the build-time VITE_API_BASE_URL, then the same origin. The web uses cookie sessions.
import { createApiClient } from '@dpw/shared';

export const API_BASE = window.__DPW_CONFIG__?.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || '';

export const api = createApiClient({
  baseUrl: API_BASE,
  auth: { kind: 'cookie' },
  onUnauthorized: () => {
    if (!location.pathname.startsWith('/login') && !location.pathname.startsWith('/set-password')) location.assign(`/login?next=${encodeURIComponent(location.pathname + location.search)}`);
  },
});
